import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const imgStyle = {
  maxWidth: 120,
  maxHeight: 120,
  objectFit: 'contain',
  border: '1px solid #e2e8f0',
  borderRadius: 6,
  padding: 4,
  margin: 4,
  verticalAlign: 'middle',
  cursor: 'pointer',
};

function Thumbnail({ src, alt }) {
  return (
    <a href={src} target="_blank" rel="noopener noreferrer">
      <img src={src} alt={alt || ''} style={imgStyle} loading="lazy" />
    </a>
  );
}

export default function MarkdownPreview({ content, direction = 'ltr' }) {
  if (!content) {
    return <p style={{ color: 'var(--text-dim)' }}>Aucun contenu Markdown.</p>;
  }

  return (
    <div className={`markdown-preview ${direction === 'rtl' ? 'rtl' : ''}`} dir={direction}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{ img: Thumbnail }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
